
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.917 0H2.083A2.086 2.086 0 000 2.083v15.834C0 19.066.935 20 2.083 20h15.834A2.086 2.086 0 0020 17.917V2.083C20 .934 19.065 0 17.917 0zm.416 2.083v7.084h-7.5v-7.5h7.084c.23 0 .416.187.416.416zm-16.25-.416h7.084v7.5h-7.5V2.083c0-.229.186-.416.416-.416zm-.416 16.25v-7.084h7.5v7.5H2.083a.417.417 0 01-.416-.416zm16.25.416h-7.084v-7.5h7.5v7.084c0 .229-.186.416-.416.416z","fill":"currentColor"}})])
          )
        }
      }
    